export { ClassicHome as Home } from './home';
export { ClassicAbout as About } from './about';
export { ClassicServices as Services } from './services';
export { ClassicContact as Contact } from './contact';
export { ClassicTeam as Team } from './team';
export { ClassicPortfolio as Portfolio } from './portfolio';
export { ClassicPackages as Packages } from './packages';
